import * as React from 'react';

import cx from 'classnames';

import './styles/SettingsContainer.scss';

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '$FlowFixMeProps'.
class SettingsContainer extends React.Component<$FlowFixMeProps> {
  render() {
    return (
      <div {...this.props} className={cx('SettingsContainer', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default SettingsContainer;
